// extracted by mini-css-extract-plugin
export default {"root":"adminSurface_root__DiTx+"};